import React from "react";
import { cleanJoin } from "../../utils/stringUtil";

function Box({
  defaultPadding = true,
  children,
  className = "",
  statusIndicatorPosition = "none",
  statusIndicatorWidth = 6,
  statusIndicatorColor = "grey",
  borderColor = "grey",
  borderWidth = 1,
  isRadiusless = false,
  isBorderless = false,
  isShadowless = true,
  ...rest
}) {
  return (
    <div
      {...rest}
      className={cleanJoin(
        "box",
        className,
        isBorderless ? "is-borderless" : "",
        isShadowless ? "is-shadowless" : "",
        defaultPadding ? "pl-5 p-2" : "",
        isRadiusless ? "is-radiusless" : "",
        !isBorderless ? `has-border-${borderColor}-${borderWidth}` : "",
        statusIndicatorPosition !== "none"
          ? `has-border-${statusIndicatorPosition}-${statusIndicatorColor}-${statusIndicatorWidth}`
          : ""
      )}
    >
      {children}
    </div>
  );
}

export default Box;
